import { cn } from '@/utils';

interface AsteriskProps {
  className?: string;
}

export function Asterisk({ className }: AsteriskProps) {
  return <span className={cn('text-red-500', className)}>*</span>;
}
